import { gqlClient } from '../../components/AppProvider';
import { ExternalConnectionModel, GetExternalConnectionsInput, RequestResult, UpsertExternalConnectionInput } from '../../gql-types.generated';
import { AppDispatch } from '../../store';
import { getErrorMessage } from '../../util/Common';
import { captureUpsertExternalConnectionStatus, captureDeleteExternalConnectionStatus, fetchError, fetchExternalConnectionListSuccess } from './ExternalConnectionSlice';
import { queryExternalConnectionList } from '../../gql/QueryExternalConnectionList';
import { mutationUpsertExternalConnection } from '../../gql/MutationUpsertExternalConnection';
import { mutationDeleteExternalConnection } from '../../gql/MutationDeleteExternalConnection';
import { ApolloError } from '@apollo/client/errors';

export const fetchExternalConnectionList = (
        filters?: GetExternalConnectionsInput
    ) => async (dispatch: AppDispatch): Promise<void> => {
        try {
            const externalConnectionList = await queryExternalConnectionList(gqlClient, filters);
            if (externalConnectionList) {
                dispatch(fetchExternalConnectionListSuccess(externalConnectionList as ExternalConnectionModel[]));
            }
        } catch (e) {
            dispatch(fetchError(e as ApolloError));
        }
    };  
    
export const upsertExternalConnection =
    (externalConnectionDetails: UpsertExternalConnectionInput) =>
        async (dispatch: AppDispatch): Promise<void> => {
            try {
                const upsertExternalConnectionStatus = await mutationUpsertExternalConnection(gqlClient, {
                    upsertExternalConnectionData: externalConnectionDetails,
                });
                if (upsertExternalConnectionStatus) {
                    if (upsertExternalConnectionStatus.result === RequestResult.Fail) {
                        dispatch(fetchError({ message: upsertExternalConnectionStatus.message } as Error));
                        getErrorMessage(upsertExternalConnectionStatus.message as string, upsertExternalConnectionStatus.errors, true, true);
                    }
                    dispatch(captureUpsertExternalConnectionStatus(upsertExternalConnectionStatus));
                }
            } catch (e) {
                dispatch(fetchError(e as ApolloError));
            }
        };

export const deleteExternalConnection =
    (externalConnectionType: string) =>
        async (dispatch: AppDispatch): Promise<void> => {
            try {
                const deleteExternalConnectionStatus = await mutationDeleteExternalConnection(gqlClient, {
                    externalConnectionType,
                });
                if (deleteExternalConnectionStatus) {
                    if (deleteExternalConnectionStatus.result === RequestResult.Fail) {
                        dispatch(fetchError({ message: deleteExternalConnectionStatus.message } as Error));
                        getErrorMessage(deleteExternalConnectionStatus.message as string, deleteExternalConnectionStatus.errors, true, true);
                    }
                    dispatch(captureDeleteExternalConnectionStatus(deleteExternalConnectionStatus));
                }
            } catch (e) {
                dispatch(fetchError(e as ApolloError));
            }
        };
